export class SurveyResponsesList {
  totalCount: number
  resndetsCount: any
  canAddResponse:boolean
  data: ListModel[]
}
export class ListModel {
  respondentsId: string
  responseNumber: string
  status: string
  submittedDate: string
  canApproved: boolean
  canReject: boolean
  canDelete: boolean
  isLessThanMinimumCompletionTime: boolean
  resondebtIds: any
  canSeletetAllRespondent: boolean
}
